<template>
    <div class="input-control">
        <select :name="name" @change="onSelectChanged" ref="select">
            <option v-for="(item, index) in options" :key="index" :value="JSON.stringify(item.value)">{{ item.label }}
            </option>
        </select>
    </div>
</template>

<script>
import InputControlBase from "@/InputControls/InputControlBase";

export default {
    name: "ComboBox",
    mixins: [InputControlBase],
    props: {
        options: Array,
    },
    mounted() {
        this.ensureValueIsValid();
    },
    methods: {
        repaintUI() {
            this.$refs.select.value = JSON.stringify(this.value);
        },
        onSelectChanged(event) {
            this.value = JSON.parse(event.currentTarget.value);
        },
        setInputValue(value) {
            for (let i = 0; i < this.options.length; i++) {
                if (this.options[i].value === value) {
                    this.value = value;
                    this.repaintUI();
                    return true
                }
            }
            return false;
        },
        focus() {
            this.$refs.select.focus();
        },
        ensureValueIsValid() {
            if (!this.setInputValue(this.value)) {
                this.setInputValue(this.options[0].value);
            }
        }
    },
    watch: {
        options() {
            this.ensureValueIsValid();
        }
    }
}
</script>

<style scoped lang="scss">
@import "input-controls";

select {
    width: 100%;
}
</style>
